import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/index';

@Component({
  selector: 'app-chart-preparation-failed',
  templateUrl: './chart-preparation-failed.component.html',
  styleUrls: ['./chart-preparation-failed.component.scss']
})
export class ChartPreparationFailedComponent implements OnInit {

  raymarineTechnicalSupport: string;

  constructor(
    public dialogRef: MatDialogRef<ChartPreparationFailedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.translateService.get('CHART_MANAGER.DOWNLOAD_CHART.CHART_PREPARATION_FAILED.STEP_6.RAYMARINE_TECHNICAL_SUPPORT')
      .subscribe(res => {
      this.raymarineTechnicalSupport = `<a href='${environment.raymarineSupportLink}' target='_blank'>${res}</a>`;
    });
  }

  ok() {
    this.dialogRef.close({
      isFinalStep: this.data.isFinalStep
    });
  }

  retry() {
    this.dialogRef.close({
      isFinalStep: this.data.isFinalStep,
      isRetry: true
    });
  }

  cancel() {
    this.dialogRef.close({
      isFinalStep: this.data.isFinalStep,
      isRetry: false
    });
  }

}
